import ParticipantsACHPage from "components/pages/ParticipantsACHPage";

export default function CaptureACHParticipants(props) {
    return <ParticipantsACHPage/>
}